import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect } from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';

var _convertPropToCssClas = convertPropToCssClassName('indeterminate-progress-indicator'),
    cssClassName = _convertPropToCssClas.cssClassName,
    classNameBlock = _convertPropToCssClas.classNameBlock,
    classNameElement = _convertPropToCssClas.classNameElement;

function DSIndeterminateProgressIndicator(_ref) {
  var containerProps = _ref.containerProps,
      title = _ref.title,
      complete = _ref.complete,
      failed = _ref.failed,
      processing = _ref.processing,
      processingComplete = _ref.processingComplete,
      processingCompleteTitle = _ref.processingCompleteTitle,
      processingFail = _ref.processingFail,
      processingFailTitle = _ref.processingFailTitle,
      animated = _ref.animated,
      percent = _ref.percent;

  var _useState = useState(title),
      _useState2 = _slicedToArray(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1];

  useEffect(function () {
    if ((processingComplete || processingFail || processing) && (complete || failed)) {
      setLabel(complete ? processingCompleteTitle : processingFailTitle);
    }
  }, [failed, complete, processingComplete, processingFail, processing]);
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-busy": processing,
    "aria-label": label,
    "aria-live": "polite",
    className: "".concat(cssClassName, " ").concat(!complete && !failed && !processing ? classNameBlock('default') : '', " ").concat(complete ? classNameBlock('complete') : '', "  ").concat( // eslint-disable-next-line max-len
    failed ? classNameBlock('failed') : '', " ").concat(processing ? classNameBlock('processing') : '', " ").concat(animated && processing ? 'animated' : '', " \n         ").concat(processingComplete ? classNameBlock('processing-complete') : '', " \n         ").concat(processingFail ? classNameBlock('processing-fail') : '', " \n      "),
    role: "alert"
  }, containerProps), /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    className: classNameBlock('tooltip-text'),
    containerComponent: /*#__PURE__*/React.createElement("div", null),
    value: label
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classNameElement('bar'))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classNameElement('bar-indicator')),
    style: {
      width: "".concat(!complete && !failed && !animated && processing ? percent : 100, "%")
    }
  })));
}

DSIndeterminateProgressIndicator.defaultProps = {
  containerProps: {},
  title: '',
  complete: false,
  failed: false,
  processing: false,
  processingComplete: false,
  processingCompleteTitle: 'Complete',
  processingFail: false,
  processingFailTitle: 'Fail',
  animated: true,
  percent: 50
};
var indeterminateProgressIndicatorProps = {
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  title: PropTypes.string.description('component s label'),
  processingCompleteTitle: PropTypes.string.description('label to display when the process is completed'),
  processingFailTitle: PropTypes.string.description('label to display when the process has failed'),
  complete: PropTypes.bool.description('Sets the process state to completed').defaultValue(false),
  failed: PropTypes.bool.description('Sets the process state to failed').defaultValue(false),
  processing: PropTypes.bool.description('Sets the process state to processing').defaultValue(false),
  processingComplete: PropTypes.bool.description('Sets the process state to processing and then completed').defaultValue(false),
  processingFail: PropTypes.bool.description('Sets the process state to processing and then failed').defaultValue(false),
  animated: PropTypes.bool.description('animate or not').defaultValue(true),
  percent: PropTypes.number.description('completion percentage').defaultValue(50)
};
DSIndeterminateProgressIndicator.propTypes = indeterminateProgressIndicatorProps;
var IndeterminateProgressIndicatorWithSchema = describe(DSIndeterminateProgressIndicator);
IndeterminateProgressIndicatorWithSchema.propTypes = indeterminateProgressIndicatorProps;

export default DSIndeterminateProgressIndicator;
export { DSIndeterminateProgressIndicator, IndeterminateProgressIndicatorWithSchema };
//# sourceMappingURL=DSIndeterminateProgressIndicator.js.map
